// =====================================
//
//   CMS 部落格內容
//   Author: Gray
//   createtime: 2016 / 11 / 07
//
// =====================================
window.InifECMobileApp.controller("CMSBlogPostController", ['$scope', '$stateParams', '$rootScope', 'CMSService', '$PreviousState', '$compile',
    function($scope, $stateParams, $rootScope, CMSService, $PreviousState, $compile) {

        // --------------------------------
        // 上一頁
        // --------------------------------
        var goBack = function() {
            
            var backState = $PreviousState.getLastState();

            if(backState == undefined) {
                backState = {
                    name: window.STATES.BLOG_LIST,
                    params: {}
                };
            }

            $PreviousState.goBack(backState);
        }

        // --------------------------------
        // [private] 取得部落格文章
        // --------------------------------
        var getBlogPost = function() {

            if($scope.isLoading || !$scope.slug) {
                return;
            }

            $scope.isLoading = true;

            CMSService.getBlogPost($scope.slug).then(function(result) {

                if(result) {
                    $scope.post = result;
                } else {
                    $scope.isError = true;
                }

                $scope.isLoading = false;

                getBlogRecommendPost();

            }, function(error) {

                $scope.isLoading = false;
                $scope.isError = true;
            })
        }

        // --------------------------------
        // 取得推薦文章
        // --------------------------------
        var getBlogRecommendPost = function() {

            var categories = [];

            if($scope.post.categories && $scope.post.categories.length > 0) {
                for(var i = 0; i < $scope.post.categories.length; i++) {
                    categories.push($scope.post.categories[i]._id);
                }
            }

            CMSService.getBlogRecommendPost($scope.post._id, categories).then(function(result) {

                if(result) {
                    $scope.recommendList = result;
                }
            });
        }

        // --------------------------------
        // [private] 初始化
        // --------------------------------
        var init = function() {

            getBlogPost();
        }

        //==========================
        //  Events
        //==========================
        $scope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {

            if(fromState.name == window.STATES.BLOG_LIST) {
                $scope.backParams = fromParams;
            } else {
                $scope.backParams = undefined;
            }
        });

        //==========================
        //  Members
        //==========================
        $scope.slug = $stateParams.slug;
        $scope.post;
        $scope.recommendList = [];
        $scope.backParams = undefined;
        $scope.SECURE_INIFEC_URL = SECURE_INIFEC_URL;

        //==========================
        //  Methods
        //==========================
        $scope.goBack = goBack;

        //==========================
        //  Init
        //==========================
        init();
    }
]);

window.InifECMobileApp.directive('dynFbPage', function () {
    
    return {
        restrict: 'A',
        scope: {},
        link: function postLink(scope, elem, attrs) {

            var createHTML = function(href, smallHeader, adaptContainerWidth, hideCover, showFacepile) {

                return '<div class="fb-page" ' +
                           'data-href="' + href + '" ' +
                           'data-small-header="' + smallHeader + '" ' +
                           'data-adapt-container-width="' + adaptContainerWidth + '" ' +
                           'data-hide-cover="' + hideCover + '" ' +
                           'data-show-facepile="' + showFacepile + '">' +
                       '</div>';
            }

            var init = function() {
                attrs.$observe('pageHref', function (newValue) {
                    var href        = newValue;
                    var smallHeader = attrs.smallHeader || false;
                    var adaptContainerWidth = attrs.adaptContainerWidth || true;
                    var hideCover = attrs.hideCover || false;
                    var showFacepile = attrs.showFacepile || true;
                    elem.html(createHTML(href, smallHeader, adaptContainerWidth, hideCover, showFacepile));

                    if(window.FB && window.FB.XFBML && window.FB.XFBML.parse) {
                        window.FB.XFBML.parse(elem[0]);    
                    }
                });
            }

            init();
        }
    };
});